import { trigger, state, animate, style, group, transition } from '@angular/animations';

export const scaleInAnimation = trigger('scaleInAnimation', [
  transition(':enter', [style({ transform: 'scale(10)', opacity: 0 }), animate('0.2s ease-out', style({ transform: 'scale(1)', opacity: 1 }))]),
  transition(':leave', [
    style({ transform: 'scale(1)', opacity: 1 }),
    group([animate('0.2s ease-in', style({ transform: 'scale(2)' })), animate('0.1s ease-in', style({ opacity: 0 }))])
  ])
]);

export const scaleOutAnimation = trigger('scaleOutAnimation', [
  transition(':enter', [style({ transform: 'scale(0)', opacity: 0 }), 
    animate('0.15s ease-out', style({ transform: 'scale(1)', opacity: 1 }))]),
  transition(':leave', [
    style({ transform: 'scale(1)', opacity: 1 }),
    group([animate('0.15s ease-in', style({ transform: 'scale(0)' })), animate('0.1s ease-in', style({ opacity: 0 }))])
  ])
]);


// export const scaleOutAnimation = trigger('scaleOutAnimation', [
//   transition(':enter', [
//     style({ transform: 'scale(0)', opacity: 0 }),
//     animate(
//       '0.4s',
//       keyframes([
//         style({ transform: 'scale(0.3) translate3d(0,0,0)', opacity: 0, offset: 0 }),
//         style({ transform: 'scale(1.1)', opacity: 0.9, offset: 0.5 }),
//         style({ transform: 'scale(0.89)', opacity: 1, offset: 0.8 }),
//         style({ transform: 'scale(1) translate3d(0,0,0)', opacity: 1, offset: 1 })
//       ])
//     )
//   ]),
//   transition(':leave', [
//     style({ transform: 'scale(1)', opacity: 1 }),
//     group([animate('0.2s ease-in', style({ transform: 'scale(0)' })), animate('0.1s ease-in', style({ opacity: 0 }))])
//   ])
// ]);
